import React from 'react'
import {Card, Table} from "antd"

const GroupBuyingGift = ({gifts}) => {

    const columns = [
        {
            title: '标签',
            dataIndex: ['category', 'name'],
            key: 'category',
        },
        {
            title: '商品名称',
            dataIndex: ['commodity', 'name'],
            key: 'commodity',
        },
        {
            title: '数量',
            dataIndex: 'quantity',
            key: 'quantity',
        },
        {
            title: '商品所属仓库',
            dataIndex: ['store', 'name'],
            key: 'store',
        }
    ]

    return (
        <div>
            <Card
                title={"赠送商品列表"}
            >
                <Table columns={columns} dataSource={gifts} rowKey={record => record.id}/>
            </Card>
        </div>
    )

}

export default GroupBuyingGift


// WEBPACK FOOTER //
// ./src/containers/GroupBuyingList/components/GroupBuyingGift.js